import o from "./workForm.vue2.js";
import "./workForm.vue3.js";
import r from "../../../../_virtual/_plugin-vue_export-helper.js";
const p = /* @__PURE__ */ r(o, [["__scopeId", "data-v-f8ffe822"]]);
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/workForm.vue.js
// module id = 1250
// module chunks = 67